interface Environment {
  imageBaseUrl: string;
  environment: 'dev' | 'prod';
  apiUrl: string;
}

const environment: Environment = {
  imageBaseUrl:
    process.env.REACT_APP_IMAGE_BASE_URL || 'https://storage.googleapis.com/ecgo-dev-deposits/',
  environment: process.env.REACT_APP_ENV || 'dev',
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8080',
} as Environment;

export default environment;
